<div class="grid grid-nogutter">
    <div class="col-12 p-0">
        <div class="p-datatable-striped">
            <p-table 
            #dt
            [value]="candidates"
            styleClass="p-datatable-sm p-datatable-sm--normal"
            [tableStyle]="{ 'min-width': '50rem' }"
            [rows]="10"
            [paginator]="true"
            [totalRecords]="candidatesCount"
            [lazy]="true"
            (onLazyLoad)="getCandidates($event)"
            [showCurrentPageReport]="true" 
            currentPageReportTemplate="Showing {first} - {last} of {totalRecords}"
            autoLayout="true"
            [scrollable]="true">
                <ng-template pTemplate="header">
                    <tr>
                        <th style="width:15%">
                            Candidate
                        </th>
                        <th style="width:15%">
                            Application Date
                        </th>
                        <th style="width:15%">
                            Projects Together
                        </th>
                        <th style="width:20%">
                            Star Rating
                        </th>
                        @if (helperService.checkResponsive()) {
                            <th alignFrozen="right" pFrozenColumn>
                              <ng-container *ngTemplateOutlet="frozenHeader"></ng-container>
                            </th>
                            } @else {
                            <th>
                              <ng-container *ngTemplateOutlet="frozenHeader"></ng-container>
                            </th>
                            }
                            <ng-template #frozenHeader>
                            Actions
                            </ng-template>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-candidate>
                    <tr class="table-data cursor-pointer" (click)="openReviewerDialog(candidate.appliedCandidateId._id)">
                        <td>{{ candidate.appliedCandidateId.firstName }} {{ candidate.appliedCandidateId.lastName }}</td>
                        @if(candidate.jobAppliedDate){
                            <td>{{ candidate.jobAppliedDate | date: 'MM/dd/yyyy' }}</td>
                        } @else {
                            <td>No start date provided</td>
                        }
                        <td>
                            {{ candidate.projectsTogether }}
                        </td>
                        <td>
                            <p-rating [(ngModel)]="candidate.defaultTenantRating" [readonly]="true" [cancel]="false" class="cursor-default"/>
                        </td>
                        @if (helperService.checkResponsive()) {
                            <td alignFrozen="right" pFrozenColumn>
                              <ng-container *ngTemplateOutlet="frozenData"></ng-container>
                            </td>
                            } @else {
                            <td>
                              <ng-container *ngTemplateOutlet="frozenData"></ng-container>
                            </td>
                            } 
                            <ng-template #frozenData>
                                <div class="wrap-actions flex align-items-center gap-2">
                                   <p-button pTooltip="Shortlist" tooltipPosition="top"
                                        [rounded]="true"
                                        [text]="true" icon="true" (click)="onShortlistCandidate($event, candidate)">
                                        <span class="{{helperService.getEnvironmentName()}}-icon icon-bookmark-star-outlined" [class.vibrant-pink]="candidate.favourite" [class.light-grey]="!candidate.favourite"></span>
                                    </p-button>
                                    <p-button class="action-icon" pTooltip="Mark not interested" tooltipPosition="top" [rounded]="true" [text]="true" icon="true" (click)="onMarkNotInterested($event, candidate)">
                                        <span class="{{helperService.getEnvironmentName()}}-icon icon-block-outlined red"></span>
                                    </p-button>
                    
                                </div>
                            </ng-template>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>

</div>